module.exports = __webpack_public_path__ + "static/media/ic_invest_learn.1470bf47.svg";